import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useCallback } from "react";

interface TelemetryFiltersProps {
  filters: {
    status: string;
    operation: string;
    search: string;
  };
  onFiltersChange: (filters: {
    status: string;
    operation: string;
    search: string;
  }) => void;
}

export function TelemetryFilters({
  filters,
  onFiltersChange,
}: TelemetryFiltersProps) {
  const clearFilters = useCallback(() => {
    onFiltersChange({
      status: "",
      operation: "",
      search: "",
    });
  }, [onFiltersChange]);

  const updateFilter = useCallback(
    (key: keyof typeof filters, value: string) => {
      onFiltersChange({
        ...filters,
        [key]: value,
      });
    },
    [filters, onFiltersChange],
  );

  return (
    <div className="flex gap-4 items-center flex-wrap shrink-0">
      <Input
        placeholder="Search spans, attributes, tools, errors..."
        value={filters.search}
        onChange={(e) => updateFilter("search", e.target.value)}
        className="max-w-sm"
      />
      <Select
        value={filters.status}
        onValueChange={(value) => updateFilter("status", value)}
      >
        <SelectTrigger className="w-32">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="">All Status</SelectItem>
          <SelectItem value="ok">OK</SelectItem>
          <SelectItem value="error">Error</SelectItem>
          <SelectItem value="cancelled">Cancelled</SelectItem>
        </SelectContent>
      </Select>
      <Select
        value={filters.operation}
        onValueChange={(value) => updateFilter("operation", value)}
      >
        <SelectTrigger className="w-40">
          <SelectValue placeholder="Operation" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="">All Operations</SelectItem>
          <SelectItem value="ai.generateText">Generate Text</SelectItem>
          <SelectItem value="ai.streamText">Stream Text</SelectItem>
          <SelectItem value="ai.toolCall">Tool Call</SelectItem>
          <SelectItem value="ai.embed">Embed</SelectItem>
        </SelectContent>
      </Select>
      <Button variant="outline" onClick={clearFilters} className="text-xs">
        Clear Filters
      </Button>
    </div>
  );
}
